import * as React from 'react';
import styled from 'styled-components';
import { Button, Box } from '@packages/ui';

import { ModuleTagTeaser } from '@packages/common';
import { List, ListLi, ListUl } from '../../List/List';
import { CallToAction } from '../CallToAction/CallToAction';
import { ImageBanner } from '../ImageBanner/ImageBanner';

const BUTTON_HEIGHT = 44;

export const Container = styled.div`
  box-sizing: border-box;
  text-align: center;

  ${ListUl} {
    list-style-type: none;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: -8px -8px;
  }

  ${ListLi as any} {
    padding: 8px 8px;
  }
`;

export const Text = styled.p``;

export const CtaLink = styled(Button).attrs({ as: 'a', 'data-testid': 'cta-link' })`
  border-radius: 6px;
  display: inline-block;
`;

export const TagLink = styled(Button).attrs({ as: 'a' })`
  display: inline-block;
  line-height: ${BUTTON_HEIGHT + 1}px;
`;

TagLink.displayName = 'TagLink';

const marginBottom = [4, 4, 5];
const textFontSize = [4, 4, 4, 6];

export type TagTeaserProps = ModuleTagTeaser;

export class TagTeaser extends React.PureComponent<TagTeaserProps> {
  renderItem = ({ item, index }: any) => {
    return (
      <CallToAction key={`${item.id}-${index}`} {...item} as={TagLink}>
        {item.title}
      </CallToAction>
    );
  };

  render() {
    const { items, text, image, cta } = this.props;
    return (
      <Container>
        {image && (
          <Box mb={marginBottom} data-testid="cms-tag-teaser-image-banner">
            <ImageBanner {...image} />
          </Box>
        )}
        {text && (
          <Box mb={marginBottom} fontSize={textFontSize}>
            {text}
          </Box>
        )}
        {items && items.length > 0 && (
          <Box mb={marginBottom}>
            <List items={items} renderItem={this.renderItem} />
          </Box>
        )}
        {cta && (
          <CallToAction {...cta} as={CtaLink}>
            {cta.title}
          </CallToAction>
        )}
      </Container>
    );
  }
}
